import { Coins, Tag, TrendingUp, type LucideIcon } from "lucide-react";

import type { BookingOpportunityKind } from "./bookingOpportunity";

/** Row affordance — matches feed `rebook_opportunity` / `first_book` icons, not Kai. */
export function bookingOpportunityRowIcon(
  kind: BookingOpportunityKind,
): LucideIcon {
  return kind === "first_book" ? Tag : TrendingUp;
}

/** Filters, rails, and widgets when no specific opportunity kind is shown. */
export const BOOKING_OPPORTUNITY_ICON: LucideIcon = Coins;
